// Lodash
import _find from 'lodash/find'
import _set from 'lodash/set'
import _isNil from 'lodash/isNil'

// Utils
import loSto from '../config/loSto'
import pubSub from '../lib/util/pubSub'

// Constants
import { LO_STO } from '../lib'
import { EMPTY_OBJECT } from '../constants/base.constants'
import {
  MINIMUM_NOTES_COUNT,
  INITIAL_GETTING_STARTED_DETAILS
} from '../constants/gettingStarted/general'
import { OOBE_TASKS_UPDATE } from '../constants/pubSub.events'
import TASK_STATUSES from '../constants/gettingStarted/taskStatuses'
import {
  TOGGLE_AGENT_TASK,
  PATIENTS_LIST_TASK,
  ASK_SUKI_TASK,
  NOTES_COMPLETION_TASK
} from '../constants/gettingStarted/tasks'

function getToggleAgentTask (tasks) {
  return _find(tasks, ['id', TOGGLE_AGENT_TASK.id]) || EMPTY_OBJECT
}

function getAskSukiTask (tasks) {
  return _find(tasks, ['id', ASK_SUKI_TASK.id]) || EMPTY_OBJECT
}

function getPatientListTask (tasks) {
  return _find(tasks, ['id', PATIENTS_LIST_TASK.id]) || EMPTY_OBJECT
}

function getNotesCountTask (tasks) {
  return _find(tasks, ['id', NOTES_COMPLETION_TASK.id]) || EMPTY_OBJECT
}

function setToggleAgentTask () {
  const oobeTaskDetails =
    loSto.get(LO_STO.OOBE_TASKS) || INITIAL_GETTING_STARTED_DETAILS
  const { tasks } = oobeTaskDetails
  const toggleAgentTask = getToggleAgentTask(tasks)
  toggleAgentTask.status = TASK_STATUSES.COMPLETED
  loSto.set(LO_STO.OOBE_TASKS, oobeTaskDetails)
  pubSub.publish(OOBE_TASKS_UPDATE)
}

function setPatientListTask () {
  const oobeTaskDetails =
    loSto.get(LO_STO.OOBE_TASKS) || INITIAL_GETTING_STARTED_DETAILS
  const { tasks } = oobeTaskDetails
  const toggleAgentTask = getPatientListTask(tasks)
  toggleAgentTask.status = TASK_STATUSES.COMPLETED
  loSto.set(LO_STO.OOBE_TASKS, oobeTaskDetails)
  pubSub.publish(OOBE_TASKS_UPDATE)
}

function setAskSukiTask () {
  const oobeTaskDetails =
    loSto.get(LO_STO.OOBE_TASKS) || INITIAL_GETTING_STARTED_DETAILS
  const { tasks } = oobeTaskDetails
  const toggleAgentTask = getAskSukiTask(tasks)
  toggleAgentTask.status = TASK_STATUSES.COMPLETED
  loSto.set(LO_STO.OOBE_TASKS, oobeTaskDetails)
  pubSub.publish(OOBE_TASKS_UPDATE)
}

function setNotesCountTask (notesCount) {
  const oobeTaskDetails =
    loSto.get(LO_STO.OOBE_TASKS) || INITIAL_GETTING_STARTED_DETAILS
  let { enabled, tasks } = oobeTaskDetails
  const notesCountTask = getNotesCountTask(tasks)
  _set(notesCountTask, 'additional.progress.tasksCompleted', notesCount)
  if (notesCount >= MINIMUM_NOTES_COUNT) {
    notesCountTask.status = TASK_STATUSES.COMPLETED
    if (_isNil(enabled)) {
      enabled = false
    }
  } else {
    if (_isNil(enabled)) {
      enabled = true
    }
  }
  loSto.set(LO_STO.OOBE_TASKS, { enabled, tasks })
  pubSub.publish(OOBE_TASKS_UPDATE)
}

export {
  setToggleAgentTask,
  setPatientListTask,
  setAskSukiTask,
  setNotesCountTask
}
